import React from 'react'
import { Switch } from 'react-router-dom'
import Clients from '../../pages/Clients'
import Audit from '../../pages/Audit'
import Route from '../Route'
import Mechanics from '../../pages/Mechanics'
import ClientDetailsPage from '../../pages/Clients/ClientDetailsPage'
import MechanicDetailsPage from '../../pages/Mechanics/MechanicsDetailsPage'
import MechanicIndications from '../../pages/MechanicIndications'
import Notifications from '../../pages/Notifications'
import Offers from '../../pages/Offers'
import Promotions from '../../pages/Promotions'
import Dashboard from '../../pages/Dashboard'
import GasStationsPrices from '../../pages/GasStationsPrices'
import ExecutiveDashboard from '../../pages/Analytics/ExecutiveDashboard'
import Workshops from '../../pages/Analytics/Workshops'
import WorkshopDetail from '../../pages/Analytics/WorkshopDetail'
import Users from '../../pages/Analytics/Users'
import Reminders from '../../pages/Analytics/Reminders'
import Maintenance from '../../pages/Analytics/Maintenance'
import Loyalty from '../../pages/Analytics/Loyalty'
import Campaigns from '../../pages/Analytics/Campaigns'
import Events from '../../pages/Analytics/Events'
import System from '../../pages/Analytics/System'

const SubRoutes = () => {
    return (
        <Switch>
            {/* never fucking puts another main component on routes of another main component, it will be fire everywhere */}
            <Route path='/dashboard' isPrivate exact component={Dashboard} />
            <Route path='/dashboard/analytics/workshops/:id' isPrivate exact component={WorkshopDetail} />
            <Route path='/dashboard/analytics/workshops' isPrivate exact component={Workshops} />
            <Route path='/dashboard/analytics/users' isPrivate exact component={Users} />
            <Route path='/dashboard/analytics/reminders' isPrivate exact component={Reminders} />
            <Route path='/dashboard/analytics/maintenance' isPrivate exact component={Maintenance} />
            <Route path='/dashboard/analytics/loyalty' isPrivate exact component={Loyalty} />
            <Route path='/dashboard/analytics/campaigns' isPrivate exact component={Campaigns} />
            <Route path='/dashboard/analytics/events' isPrivate exact component={Events} />
            <Route path='/dashboard/analytics/system' isPrivate exact component={System} />
            <Route path='/dashboard/analytics' isPrivate exact component={ExecutiveDashboard} />
            <Route path='/dashboard/clientes' isPrivate exact component={Clients} />
            <Route path='/dashboard/clientes/detalhes' isPrivate exact component={ClientDetailsPage} />
            <Route path='/dashboard/mecânicas/detalhes' isPrivate exact component={MechanicDetailsPage} />
            <Route path='/dashboard/mecânicas' isPrivate exact component={Mechanics} />
            <Route path='/dashboard/notificações' exact isPrivate component={Notifications} />
            <Route path='/dashboard/ofertas' exact isPrivate component={Offers} />
            <Route path='/dashboard/preços-postos-de-gasolina' exact isPrivate component={GasStationsPrices} />
            <Route path='/dashboard/promoções' exact isPrivate component={Promotions} />
            <Route path='/dashboard/auditoria' exact isPrivate component={Audit} />
            <Route path='/dashboard/indicações' exact isPrivate component={MechanicIndications} />
        </Switch>
    )
}

export default SubRoutes
